/**
 * @fileoverview Let staff pick an existing event to edit from the calendar form, opened by `5_Actions.js`. The registered `/api/events` route supplies current records. Choosing a row stores it as Redux `currentlyEditingEvent`, which switches the form to that event; the enclosing calendar workspace owns the eventual save.
 */

import { useSelector, useDispatch } from 'react-redux'
import api from '../../api'
import { useEffect, useState } from 'react'
import {
    setCurrentlyEditingEvent,
    setEventsTableVisible,

} from '../../store/CalendarInput/action'
import { Column } from '../shared/AppColumn'
import { DataTable } from '../shared/AppDataTable'
import { Dialog } from '../shared/AppDialog'





const EventsTableDialog = () => {
    const dispatch = useDispatch()
    const visible = useSelector(state => state.calendarInput.eventsTableVisible)
    const currentlyEditingEvent = useSelector(state => state.calendarInput.currentlyEditingEvent)
    const [events, setEvents] = useState([])




    function truncateText(text, length) {
        if (text && text.length > length) {
            return text.substring(0, length - 3) + '...'
        }
        return text
    }

    const fetchCalendarEvents = async () => {
        api.get('/events')
            .then((response) => {
                const items = response.data.map(item => ({
                    ...item,
                    formattedStart: new Date(item.start).toLocaleString(),
                    formattedEnd: new Date(item.end).toLocaleString(),
                    shortDescription: truncateText(item.description, 50),
                }))
                setEvents(items)
            })
            .catch(error => {
                console.log(error)
            })
    }

    useEffect(() => {
        fetchCalendarEvents()
    }, [])


    return (
        <>
            <Dialog className="created-events-panel" header="Choose an Event to Edit" visible={visible} onHide={() => dispatch(setEventsTableVisible(false))} modal dismissableMask style={{ padding: '0', width: '70%', height: '90%' }}>
                <div className="surface-card p-0 shadow-2 border-round overflow-hidden matters-table">
                    <DataTable value={events} className="p-datatable-striped"
                        selectionMode="single" selection={currentlyEditingEvent}
                        onSelectionChange={(e) => {
                            dispatch(setCurrentlyEditingEvent(e.value))
                            dispatch(setEventsTableVisible(false))
                        }}
                        size="small" paginator rows={25} paginatorPosition="both"
                        removableSort
                    >
                        <Column field="title" header="Title" sortable style={{ width: '30%' }}></Column>
                        <Column field="shortDescription" header="Description" sortable style={{ width: '30%' }}></Column>
                        <Column field="formattedStart" header="Start" sortable style={{ width: '20%' }}></Column>
                        <Column field="formattedEnd" header="End" sortable style={{ width: '20%' }}></Column>
                    </DataTable>
                </div>
            </Dialog>
        </>
    )
}

export default EventsTableDialog
